import { SegmentFilterCategorySpecificField, SegmentFilterState } from 'domains/segments/types';

export type FilterGroupNode = {
    id: string;
    matchType: 'AND' | 'OR';
    children: FilterTreeNode[];
};

export type FilterTreeLeaf = {
    type: 'filter';
    id: string;
    filter: SegmentFilterState<SegmentFilterCategorySpecificField>;
};

export type FilterTreeGroup = {
    type: 'group';
    id: string;
    group: FilterGroupNode;
};

export type FilterTreeNode = FilterTreeLeaf | FilterTreeGroup;

export const MAX_NESTING_DEPTH = 2;
